// extracted by mini-css-extract-plugin
export var pageTitle = "product-page-module--pageTitle--3Bo0D";